;(function ($, _, window) {
    /** 
    * ECHTINTERACTIE, http://wijzijnecht.nl        
    * Construct the slider
    *
    * Example:  data-slider='' data-slider-config='{"duration":"4000","prevnext":true}'
    * TO-DO slider items dmv obj ipv dom creatie
    */ 
    var newsSlider = function ($target, options) {
        /**
         * Check for jquery
         */
        if ($ === undefined) {
            throw '[data-newsSlider] jquery is required';
        }

        /**
         * Check for lodash
         */
        if (_ === undefined) {
            throw '[data-newsSlider] lodash is required';
        }
        
        /**
        * Set local variables
        */
        var config = {
    		prevnext: true,
    		pagination: true,
    		timer:true,
            duration:6000,
            className: {
                active: 'is--current'
            }
	    }; 
    
        this.$target = $target; //is obj
        this.options = $.extend(true, config, options);
        this.$slider_wrapper = $(this.options.wrapper);
        this.$slider_items = $(this.options.items);
        this.$tmpl_paging = $("script#tmpl-slider-paging").html() ? _.template($("script#tmpl-slider-paging").html()) : false;
        this.timer = '' //timer variable for auto loop function
        this.currentIndex = 0;
        this.hover = false;

        if(window.breakpoint() == 'breakpoint-mobile') {
            this.options.timer = false;
            this.options.pagination = false;
            this.options.prevnext = false;
        }
        
        //call _init function
        this._init();
    };


    /**
    *  init Slider function  
    **/    
    newsSlider.prototype._init = function () {
        var self=this; 
 
        $(this.$slider_items[this.currentIndex]).addClass(this.options.className.active);
        // console.log(this.$slider_items.length );
        if(this.$slider_items.length > 1) {
            this._setPagination();
            this._setTimer();   

            this.$slider_wrapper.bind('mouseover', function() {
                if(!self.hover) {
                    clearInterval(self.timer);
                    self.hover = true;
                }
            });
    
            this.$slider_wrapper.bind('mouseout', function() {
                
                self._setTimer();
                self.hover = false;
            });
        }

       
    };
    

    /**
    * Set Prev and Next buttons function;
    **/
    
    /**
    * Go to next slide function
    * used by prev and next button and timer function
    **/
    newsSlider.prototype._nextItem = function(pos) {
        var self=this,
            pageItems = this.$target.find('.header-page-item'),
            itemsLength = this.$slider_items.length;
        // console.log(pos, itemsLength);

        $(this.$slider_items[pos - 1]).removeClass(this.options.className.active);
        $(pageItems[pos - 1]).removeClass(this.options.className.active);
       

        if(pos >= itemsLength) {
            this.currentIndex = 0;
        } else {
            this.currentIndex = pos;
        }

        $(this.$slider_items[this.currentIndex]).addClass(this.options.className.active);
        $(pageItems[this.currentIndex]).addClass(this.options.className.active);
        // this._updateNavigationControls();
    };
    
    
    /**
    * Set pagination function
    **/
    newsSlider.prototype._setPagination = function() {
        var self = this,
            objPaging = $(this.$tmpl_paging({"data": self.$slider_items}));

        //console.log(self.items, objPaging2);
        this.$target.append(objPaging);
        $(this.$target.find('.header-page-item')[0]).addClass(this.options.className.active); //set first active
        $(this.$target.find('.header-page-item')).bind('click', function(e) {
            
            var pos = parseInt($(this).text());
            clearInterval(self.timer);
            $(self.$target).find('.'+self.options.className.active).removeClass(self.options.className.active);
            $(self.$target).find('.header-page-item.'+self.options.className.active).removeClass(self.options.className.active);
            
            $(self.$slider_items[pos-1]).addClass(self.options.className.active);
            $(this).addClass(self.options.className.active);
            self.currentIndex = pos - 1;
            // self._setTimer();

        });
    };
    
    
    /**
    * update update pagination and prev next buttons
    **/
    newsSlider.prototype._updateNavigationControls = function() {
        var self=this,
            pageItems = this.$target.find('.header-page-item'),
            nextCount = this.currentIndex;

            // console.log(nextCount);
        
        $(pageItems[nextCount - 1]).removeClass(this.options.className.active);
        $(pageItems[nextCount]).addClass(this.options.className.active);

        //update  paginatio
    };
  


    
    /**
    * Timer function
    **/
    newsSlider.prototype._setTimer = function() {
        var self=this;
            
        self.timer= setInterval(function() {
            // Do something after 5 seconds
            var next = self.currentIndex+1;
		    self._nextItem(next);
	  	}, self.options.duration);
            
    };
    
    
    /**
     * On DOM ready
     */
    $(function () {
        /**
         * Initialize newsSlider 
         */
        $('[data-newsslider]').each(function () {
            var $target = $(this),
                options = $target.data('newsslider');

            new newsSlider($target, options);
        });

    });

})(jQuery, _, window);